import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { selectIsOrgStaffTeamView, setOrgStaffTeamView } from "rdx/modules/enterpriseProjects/slice";
import ToggleButtons from "components/mui-styled-components/Buttons/ToggleButtons";

const FilterByTeamViewButton = () => {
  const dispatch = useDispatch();
  const isOrgStaffTeamView = useSelector(selectIsOrgStaffTeamView);

  const toggleTeamView = () => {
    dispatch(setOrgStaffTeamView(!isOrgStaffTeamView));
  };

  return (
    <ToggleButtons
      buttonOptions={[
        { label: "View All", value: false },
        { label: "View My Team", value: true },
      ]}
      value={isOrgStaffTeamView}
      updateValue={toggleTeamView}
    />
  );
};

export default FilterByTeamViewButton;
